export default __webpack_public_path__ + "static/media/face-id_9648194.599659e4.svg";